import "./index.scss";

import { FormControlLabel } from "@mui/material";
import Checkbox from "@mui/material/Checkbox";
import { ReactComponent as UncheckIcon } from "assets/images/toggle-checkboxes/square/off-normal.svg";
import { ReactComponent as CheckedIcon } from "assets/images/toggle-checkboxes/square/on-normal.svg";
import { ReactComponent as CheckedIconOrange } from "assets/images/toggle-checkboxes/square/on-orange.svg";
import React, { FC, memo, useCallback } from "react";

interface CheckBoxProps {
  label?: any;
  checked?: boolean;
  onChange?: (value: boolean) => void;
  isOrange?: boolean;
}

const CheckBoxComponent: FC<CheckBoxProps> = (props: CheckBoxProps) => {
  const { label = "", checked = false, onChange, isOrange = false } = props;

  const _handleChange = useCallback(
    (e: any, checked: boolean) => {
      onChange && onChange(checked);
    },
    [onChange]
  );

  return (
    <FormControlLabel
      label={label}
      control={
        <Checkbox
          checked={checked}
          icon={<UncheckIcon />}
          checkedIcon={isOrange ? <CheckedIconOrange /> : <CheckedIcon />}
          onChange={_handleChange}
        />
      }
    />
  );
};

const CheckBox = memo(CheckBoxComponent);
export default CheckBox;
